import { Fragment, useContext, useEffect, useState } from "react";

import { Card, Link as DSLink } from "@icg360/design-system";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/common/table";
import { AuthAppContext } from "components/root/auth-app-provider";
import { CONFIG } from "config";
import {
  dateStringForState,
  getApiDatetimeFromRoute,
  openDocument,
} from "utils";

type DocList = Array<{ label: string; createdAt: string; route: string }>;

export const AllPolicyDocs = () => {
  const { userDocuments, userDetails, policy } = useContext(AuthAppContext);
  const [docs, setDocs] = useState<DocList>([]);

  useEffect(() => {
    if (userDetails && userDocuments) {
      const { grouped } = userDocuments;
      const { isCommercial } = userDetails;
      const flatDocs = grouped?.flat() ?? [];
      setDocs(
        flatDocs
          .reduce((result: DocList, document) => {
            const { route, label, lastUpdated, templateId } = document;
            if (
              isCommercial &&
              [
                "BOPRenewalNoticeSICSC",
                "BOPRenewalProposalSICSC",
                "BOPRenewalProposalSICLA",
                "BOPRenewalProposalSICNC",
              ].includes(templateId ?? "")
            ) {
              return result;
            }
            const hrefDate = getApiDatetimeFromRoute(route ?? "");
            const lastUpdatedDate = new Date(Number(lastUpdated));
            const createdAt =
              hrefDate > lastUpdatedDate
                ? lastUpdatedDate.toISOString()
                : hrefDate.toISOString();
            result.push({
              route: route ?? "",
              label: label ?? "",
              createdAt,
            });
            return result;
          }, [])
          .sort((a, b) => {
            if (a.createdAt < b.createdAt) {
              return 1;
            }
            if (a.createdAt > b.createdAt) {
              return -1;
            }
            return 0;
          })
      );
    }
  }, [userDetails, userDocuments]);

  const propertyState = policy?.propertyAddress?.state ?? "NJ";

  return (
    <Card title="All policy documents">
      {docs.length !== 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Date</TableHeader>
              <TableHeader>Document</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {docs.map(({ label, createdAt, route }) => (
              <Fragment key={route}>
                <TableRow>
                  <TableCell>
                    {dateStringForState(createdAt, propertyState)}
                  </TableCell>
                  <TableCell>
                    <DSLink
                      onPress={() => {
                        openDocument(`${CONFIG.KEYSTONE_PROXY_HREF}${route}`);
                      }}
                    >
                      {label}
                    </DSLink>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </TableBody>
        </Table>
      ) : (
        <div>There are no policy documents available at this time.</div>
      )}
    </Card>
  );
};
